<div
  class="tw-w-full tw-h-fit tw-sticky tw-flex tw-justify-between tw-items-center tw-bg-secondary tw-rounded-es-[10px] tw-rounded-ee-[10px] tw-top-0 tw-px-8 tw-py-4 tw-z-[99999]"
>
  <div
    [ngClass]="showBackIcon ? 'tw-visible' : 'tw-invisible'"
    class="tw-w-7 tw-h-7 tw-rounded-full tw-flex tw-justify-center tw-items-center tw-bg-white"
  >
    <img (click)="goBack()" class="tw-w-6 tw-h-6 tw-object-contain" src="../../../assets/back-icon.svg" />
  </div>
  <img class="tw-w-32 tw-h-12 tw-object-contain" src="../../../assets/logo.svg" />
  <img (click)="goToProfile()" class="tw-w-7 tw-h-7 tw-object-contain" src="../../../assets/profile.svg" />
</div>
